import React from 'react'
import { SummaryToast, SummaryToastVariant } from '../Common/SummaryToast'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { hideToast, selectShowToast, selectToastConfig } from '../../../../../store/meetingSummary/display'

export interface ToastConfig {
  variant: SummaryToastVariant
  icon: string
  message: string
}

export const MeetingSummaryToast = () => {
  const dispatch = useAppDispatch()

  const toastConfig = useAppSelector(selectToastConfig)
  const showToast = useAppSelector(selectShowToast)

  if (!toastConfig) {
    return null
  }

  const { variant, icon, message } = toastConfig

  const closeToast = () => {
    dispatch(hideToast())
  }

  return (
    <SummaryToast variant={variant} show={showToast} onClose={closeToast}>
      <i className={`bi ${icon}`} />
      <span className='paragraph-medium'>{message}</span>
    </SummaryToast>
  )
}
